/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as IndexRouteImport } from './routes/index'
import { Route as AuthenticatedRouteImport } from './routes/_authenticated'
import { Route as OnboardingRouteImport } from './routes/onboarding'
import { Route as UserBlockedRouteImport } from './routes/user-blocked'
import { Route as AuthenticatedDiaryRouteRouteImport } from './routes/_authenticated/diary/route'
import { Route as AuthenticatedSocialMatchRouteRouteImport } from './routes/_authenticated/social-match/route'
import { Route as AuthenticatedVerifyAgeRouteImport } from './routes/_authenticated/verify-age'
import { Route as OnboardingIndexRouteImport } from './routes/onboarding/index'
import { Route as OnboardingLanguageRouteImport } from './routes/onboarding/language'
import { Route as OnboardingNameRouteImport } from './routes/onboarding/name'
import { Route as OnboardingSigninEmailRouteImport } from './routes/onboarding/signin-email'
import { Route as OnboardingSigninVerificationRouteImport } from './routes/onboarding/signin-verification'
import { Route as OnboardingSigninWelcomeRouteImport } from './routes/onboarding/signin-welcome'
import { Route as OnboardingSignupAgeRestrictedRouteImport } from './routes/onboarding/signup-age-restricted'
import { Route as OnboardingSignupCityRouteImport } from './routes/onboarding/signup-city'
import { Route as OnboardingSignupDateOfBirthRouteImport } from './routes/onboarding/signup-date-of-birth'
import { Route as OnboardingSignupEmailRouteImport } from './routes/onboarding/signup-email'
import { Route as OnboardingSignupEmailAlreadyExistsRouteImport } from './routes/onboarding/signup-email-already-exists'
import { Route as OnboardingSignupEmailChangeRouteImport } from './routes/onboarding/signup-email-change'
import { Route as OnboardingSignupEmailVerificationRouteImport } from './routes/onboarding/signup-email-verification'
import { Route as OnboardingSignupGenderRouteImport } from './routes/onboarding/signup-gender'
import { Route as OnboardingSignupHeardAboutRouteImport } from './routes/onboarding/signup-heard-about'
import { Route as OnboardingSignupInstagramRouteImport } from './routes/onboarding/signup-instagram'
import { Route as OnboardingSignupIntentionRouteImport } from './routes/onboarding/signup-intention'
import { Route as OnboardingSignupWelcomeRouteImport } from './routes/onboarding/signup-welcome'
import { Route as AuthenticatedCharacterCharacterRouteImport } from './routes/_authenticated/character/$character'
import { Route as AuthenticatedChatIndexRouteImport } from './routes/_authenticated/chat/index'
import { Route as AuthenticatedDiaryIndexRouteImport } from './routes/_authenticated/diary/index'
import { Route as AuthenticatedDiaryThoughtIdRouteImport } from './routes/_authenticated/diary/$thoughtId'
import { Route as AuthenticatedDiaryNewRouteImport } from './routes/_authenticated/diary/new'
import { Route as AuthenticatedFeedIndexRouteImport } from './routes/_authenticated/feed/index'
import { Route as AuthenticatedFeedNewRouteImport } from './routes/_authenticated/feed/new'
import { Route as AuthenticatedFriendFriendIdRouteImport } from './routes/_authenticated/friend/$friendId'
import { Route as AuthenticatedHomeIndexRouteImport } from './routes/_authenticated/home/index'
import { Route as AuthenticatedHomeNewRouteImport } from './routes/_authenticated/home/new'
import { Route as AuthenticatedProfileIndexRouteImport } from './routes/_authenticated/profile/index'
import { Route as AuthenticatedProfileAvatarRouteImport } from './routes/_authenticated/profile/avatar'
import { Route as AuthenticatedProfileEiLeaderboardRouteImport } from './routes/_authenticated/profile/ei-leaderboard'
import { Route as AuthenticatedProfileEiResultRouteImport } from './routes/_authenticated/profile/ei-result'
import { Route as AuthenticatedProfileEiTestRouteImport } from './routes/_authenticated/profile/ei-test'
import { Route as AuthenticatedProfileFriendsLanguageRouteImport } from './routes/_authenticated/profile/friends-language'
import { Route as AuthenticatedProfileInterfaceLanguageRouteImport } from './routes/_authenticated/profile/interface-language'
import { Route as AuthenticatedProfilePersonalityRouteImport } from './routes/_authenticated/profile/personality'
import { Route as AuthenticatedProfilePersonalityShareRouteImport } from './routes/_authenticated/profile/personality-share'
import { Route as AuthenticatedProfileRankRouteImport } from './routes/_authenticated/profile/rank'
import { Route as AuthenticatedProfileRankPointsRouteImport } from './routes/_authenticated/profile/rank-points'
import { Route as AuthenticatedSocialMatchIndexRouteImport } from './routes/_authenticated/social-match/index'
import { Route as AuthenticatedSocialMatchDashboardRouteImport } from './routes/_authenticated/social-match/dashboard'
import { Route as AuthenticatedSocialMatchRequestRouteImport } from './routes/_authenticated/social-match/request'
import { Route as AuthenticatedSocialMatchSubmittedRouteImport } from './routes/_authenticated/social-match/submitted'
import { Route as AuthenticatedBoardCharacterCharacterRouteImport } from './routes/_authenticated/board/character/$character'
import { Route as AuthenticatedBoardFriendFriendIdRouteImport } from './routes/_authenticated/board/friend/$friendId'
import { Route as AuthenticatedFriendFriendIdIndexRouteImport } from './routes/_authenticated/friend/$friendId.index'
import { Route as AuthenticatedFriendFriendIdPersonalityRouteImport } from './routes/_authenticated/friend/$friendId.personality'
import { Route as AuthenticatedFriendFriendIdScenarioRouteImport } from './routes/_authenticated/friend/$friendId.scenario'
import { Route as AuthenticatedNewContactPreviewFriendIdRouteImport } from './routes/_authenticated/new-contact/preview.$friendId'
import { Route as AuthenticatedProfileBlacklistIndexRouteImport } from './routes/_authenticated/profile/blacklist/index'
import { Route as AuthenticatedProfileBlacklistFriendIdRouteImport } from './routes/_authenticated/profile/blacklist/$friendId'
import { Route as AuthenticatedProfileEmailSendRouteImport } from './routes/_authenticated/profile/email/send'
import { Route as AuthenticatedProfileEmailVerifyRouteImport } from './routes/_authenticated/profile/email/verify'
import { Route as AuthenticatedProfileSubscriptionIndexRouteImport } from './routes/_authenticated/profile/subscription/index'
import { Route as AuthenticatedProfileSubscriptionChangeRouteImport } from './routes/_authenticated/profile/subscription/change'

const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthenticatedRoute = AuthenticatedRouteImport.update({
  id: '/_authenticated',
  getParentRoute: () => rootRouteImport,
} as any)
const OnboardingRoute = OnboardingRouteImport.update({
  id: '/onboarding',
  path: '/onboarding',
  getParentRoute: () => rootRouteImport,
} as any)
const UserBlockedRoute = UserBlockedRouteImport.update({
  id: '/user-blocked',
  path: '/user-blocked',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthenticatedDiaryRouteRoute = AuthenticatedDiaryRouteRouteImport.update({
  id: '/diary',
  path: '/diary',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedSocialMatchRouteRoute =
  AuthenticatedSocialMatchRouteRouteImport.update({
    id: '/social-match',
    path: '/social-match',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedVerifyAgeRoute = AuthenticatedVerifyAgeRouteImport.update({
  id: '/verify-age',
  path: '/verify-age',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const OnboardingIndexRoute = OnboardingIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => OnboardingRoute,
} as any)
const OnboardingLanguageRoute = OnboardingLanguageRouteImport.update({
  id: '/language',
  path: '/language',
  getParentRoute: () => OnboardingRoute,
} as any)
const OnboardingNameRoute = OnboardingNameRouteImport.update({
  id: '/name',
  path: '/name',
  getParentRoute: () => OnboardingRoute,
} as any)
const OnboardingSigninEmailRoute = OnboardingSigninEmailRouteImport.update({
  id: '/signin-email',
  path: '/signin-email',
  getParentRoute: () => OnboardingRoute,
} as any)
const OnboardingSigninVerificationRoute =
  OnboardingSigninVerificationRouteImport.update({
    id: '/signin-verification',
    path: '/signin-verification',
    getParentRoute: () => OnboardingRoute,
  } as any)
const OnboardingSigninWelcomeRoute = OnboardingSigninWelcomeRouteImport.update({
  id: '/signin-welcome',
  path: '/signin-welcome',
  getParentRoute: () => OnboardingRoute,
} as any)
const OnboardingSignupAgeRestrictedRoute =
  OnboardingSignupAgeRestrictedRouteImport.update({
    id: '/signup-age-restricted',
    path: '/signup-age-restricted',
    getParentRoute: () => OnboardingRoute,
  } as any)
const OnboardingSignupCityRoute = OnboardingSignupCityRouteImport.update({
  id: '/signup-city',
  path: '/signup-city',
  getParentRoute: () => OnboardingRoute,
} as any)
const OnboardingSignupDateOfBirthRoute =
  OnboardingSignupDateOfBirthRouteImport.update({
    id: '/signup-date-of-birth',
    path: '/signup-date-of-birth',
    getParentRoute: () => OnboardingRoute,
  } as any)
const OnboardingSignupEmailRoute = OnboardingSignupEmailRouteImport.update({
  id: '/signup-email',
  path: '/signup-email',
  getParentRoute: () => OnboardingRoute,
} as any)
const OnboardingSignupEmailAlreadyExistsRoute =
  OnboardingSignupEmailAlreadyExistsRouteImport.update({
    id: '/signup-email-already-exists',
    path: '/signup-email-already-exists',
    getParentRoute: () => OnboardingRoute,
  } as any)
const OnboardingSignupEmailChangeRoute =
  OnboardingSignupEmailChangeRouteImport.update({
    id: '/signup-email-change',
    path: '/signup-email-change',
    getParentRoute: () => OnboardingRoute,
  } as any)
const OnboardingSignupEmailVerificationRoute =
  OnboardingSignupEmailVerificationRouteImport.update({
    id: '/signup-email-verification',
    path: '/signup-email-verification',
    getParentRoute: () => OnboardingRoute,
  } as any)
const OnboardingSignupGenderRoute = OnboardingSignupGenderRouteImport.update({
  id: '/signup-gender',
  path: '/signup-gender',
  getParentRoute: () => OnboardingRoute,
} as any)
const OnboardingSignupHeardAboutRoute =
  OnboardingSignupHeardAboutRouteImport.update({
    id: '/signup-heard-about',
    path: '/signup-heard-about',
    getParentRoute: () => OnboardingRoute,
  } as any)
const OnboardingSignupInstagramRoute =
  OnboardingSignupInstagramRouteImport.update({
    id: '/signup-instagram',
    path: '/signup-instagram',
    getParentRoute: () => OnboardingRoute,
  } as any)
const OnboardingSignupIntentionRoute =
  OnboardingSignupIntentionRouteImport.update({
    id: '/signup-intention',
    path: '/signup-intention',
    getParentRoute: () => OnboardingRoute,
  } as any)
const OnboardingSignupWelcomeRoute = OnboardingSignupWelcomeRouteImport.update({
  id: '/signup-welcome',
  path: '/signup-welcome',
  getParentRoute: () => OnboardingRoute,
} as any)
const AuthenticatedCharacterCharacterRoute =
  AuthenticatedCharacterCharacterRouteImport.update({
    id: '/character/$character',
    path: '/character/$character',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedChatIndexRoute = AuthenticatedChatIndexRouteImport.update({
  id: '/chat/',
  path: '/chat/',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedDiaryIndexRoute = AuthenticatedDiaryIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AuthenticatedDiaryRouteRoute,
} as any)
const AuthenticatedDiaryThoughtIdRoute =
  AuthenticatedDiaryThoughtIdRouteImport.update({
    id: '/$thoughtId',
    path: '/$thoughtId',
    getParentRoute: () => AuthenticatedDiaryRouteRoute,
  } as any)
const AuthenticatedDiaryNewRoute = AuthenticatedDiaryNewRouteImport.update({
  id: '/new',
  path: '/new',
  getParentRoute: () => AuthenticatedDiaryRouteRoute,
} as any)
const AuthenticatedFeedIndexRoute = AuthenticatedFeedIndexRouteImport.update({
  id: '/feed/',
  path: '/feed/',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedFeedNewRoute = AuthenticatedFeedNewRouteImport.update({
  id: '/feed/new',
  path: '/feed/new',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedFriendFriendIdRoute =
  AuthenticatedFriendFriendIdRouteImport.update({
    id: '/friend/$friendId',
    path: '/friend/$friendId',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedHomeIndexRoute = AuthenticatedHomeIndexRouteImport.update({
  id: '/home/',
  path: '/home/',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedHomeNewRoute = AuthenticatedHomeNewRouteImport.update({
  id: '/home/new',
  path: '/home/new',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedProfileIndexRoute =
  AuthenticatedProfileIndexRouteImport.update({
    id: '/profile/',
    path: '/profile/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedProfileAvatarRoute =
  AuthenticatedProfileAvatarRouteImport.update({
    id: '/profile/avatar',
    path: '/profile/avatar',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedProfileEiLeaderboardRoute =
  AuthenticatedProfileEiLeaderboardRouteImport.update({
    id: '/profile/ei-leaderboard',
    path: '/profile/ei-leaderboard',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedProfileEiResultRoute =
  AuthenticatedProfileEiResultRouteImport.update({
    id: '/profile/ei-result',
    path: '/profile/ei-result',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedProfileEiTestRoute =
  AuthenticatedProfileEiTestRouteImport.update({
    id: '/profile/ei-test',
    path: '/profile/ei-test',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedProfileFriendsLanguageRoute =
  AuthenticatedProfileFriendsLanguageRouteImport.update({
    id: '/profile/friends-language',
    path: '/profile/friends-language',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedProfileInterfaceLanguageRoute =
  AuthenticatedProfileInterfaceLanguageRouteImport.update({
    id: '/profile/interface-language',
    path: '/profile/interface-language',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedProfilePersonalityRoute =
  AuthenticatedProfilePersonalityRouteImport.update({
    id: '/profile/personality',
    path: '/profile/personality',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedProfilePersonalityShareRoute =
  AuthenticatedProfilePersonalityShareRouteImport.update({
    id: '/profile/personality-share',
    path: '/profile/personality-share',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedProfileRankRoute =
  AuthenticatedProfileRankRouteImport.update({
    id: '/profile/rank',
    path: '/profile/rank',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedProfileRankPointsRoute =
  AuthenticatedProfileRankPointsRouteImport.update({
    id: '/profile/rank-points',
    path: '/profile/rank-points',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedSocialMatchIndexRoute =
  AuthenticatedSocialMatchIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthenticatedSocialMatchRouteRoute,
  } as any)
const AuthenticatedSocialMatchDashboardRoute =
  AuthenticatedSocialMatchDashboardRouteImport.update({
    id: '/dashboard',
    path: '/dashboard',
    getParentRoute: () => AuthenticatedSocialMatchRouteRoute,
  } as any)
const AuthenticatedSocialMatchRequestRoute =
  AuthenticatedSocialMatchRequestRouteImport.update({
    id: '/request',
    path: '/request',
    getParentRoute: () => AuthenticatedSocialMatchRouteRoute,
  } as any)
const AuthenticatedSocialMatchSubmittedRoute =
  AuthenticatedSocialMatchSubmittedRouteImport.update({
    id: '/submitted',
    path: '/submitted',
    getParentRoute: () => AuthenticatedSocialMatchRouteRoute,
  } as any)
const AuthenticatedBoardCharacterCharacterRoute =
  AuthenticatedBoardCharacterCharacterRouteImport.update({
    id: '/board/character/$character',
    path: '/board/character/$character',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedBoardFriendFriendIdRoute =
  AuthenticatedBoardFriendFriendIdRouteImport.update({
    id: '/board/friend/$friendId',
    path: '/board/friend/$friendId',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedFriendFriendIdIndexRoute =
  AuthenticatedFriendFriendIdIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthenticatedFriendFriendIdRoute,
  } as any)
const AuthenticatedFriendFriendIdPersonalityRoute =
  AuthenticatedFriendFriendIdPersonalityRouteImport.update({
    id: '/personality',
    path: '/personality',
    getParentRoute: () => AuthenticatedFriendFriendIdRoute,
  } as any)
const AuthenticatedFriendFriendIdScenarioRoute =
  AuthenticatedFriendFriendIdScenarioRouteImport.update({
    id: '/scenario',
    path: '/scenario',
    getParentRoute: () => AuthenticatedFriendFriendIdRoute,
  } as any)
const AuthenticatedNewContactPreviewFriendIdRoute =
  AuthenticatedNewContactPreviewFriendIdRouteImport.update({
    id: '/new-contact/preview/$friendId',
    path: '/new-contact/preview/$friendId',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedProfileBlacklistIndexRoute =
  AuthenticatedProfileBlacklistIndexRouteImport.update({
    id: '/profile/blacklist/',
    path: '/profile/blacklist/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedProfileBlacklistFriendIdRoute =
  AuthenticatedProfileBlacklistFriendIdRouteImport.update({
    id: '/profile/blacklist/$friendId',
    path: '/profile/blacklist/$friendId',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedProfileEmailSendRoute =
  AuthenticatedProfileEmailSendRouteImport.update({
    id: '/profile/email/send',
    path: '/profile/email/send',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedProfileEmailVerifyRoute =
  AuthenticatedProfileEmailVerifyRouteImport.update({
    id: '/profile/email/verify',
    path: '/profile/email/verify',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedProfileSubscriptionIndexRoute =
  AuthenticatedProfileSubscriptionIndexRouteImport.update({
    id: '/profile/subscription/',
    path: '/profile/subscription/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedProfileSubscriptionChangeRoute =
  AuthenticatedProfileSubscriptionChangeRouteImport.update({
    id: '/profile/subscription/change',
    path: '/profile/subscription/change',
    getParentRoute: () => AuthenticatedRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/onboarding': typeof OnboardingRouteWithChildren
  '/user-blocked': typeof UserBlockedRoute
  '/diary': typeof AuthenticatedDiaryRouteRouteWithChildren
  '/social-match': typeof AuthenticatedSocialMatchRouteRouteWithChildren
  '/verify-age': typeof AuthenticatedVerifyAgeRoute
  '/onboarding/language': typeof OnboardingLanguageRoute
  '/onboarding/name': typeof OnboardingNameRoute
  '/onboarding/signin-email': typeof OnboardingSigninEmailRoute
  '/onboarding/signin-verification': typeof OnboardingSigninVerificationRoute
  '/onboarding/signin-welcome': typeof OnboardingSigninWelcomeRoute
  '/onboarding/signup-age-restricted': typeof OnboardingSignupAgeRestrictedRoute
  '/onboarding/signup-city': typeof OnboardingSignupCityRoute
  '/onboarding/signup-date-of-birth': typeof OnboardingSignupDateOfBirthRoute
  '/onboarding/signup-email': typeof OnboardingSignupEmailRoute
  '/onboarding/signup-email-already-exists': typeof OnboardingSignupEmailAlreadyExistsRoute
  '/onboarding/signup-email-change': typeof OnboardingSignupEmailChangeRoute
  '/onboarding/signup-email-verification': typeof OnboardingSignupEmailVerificationRoute
  '/onboarding/signup-gender': typeof OnboardingSignupGenderRoute
  '/onboarding/signup-heard-about': typeof OnboardingSignupHeardAboutRoute
  '/onboarding/signup-instagram': typeof OnboardingSignupInstagramRoute
  '/onboarding/signup-intention': typeof OnboardingSignupIntentionRoute
  '/onboarding/signup-welcome': typeof OnboardingSignupWelcomeRoute
  '/onboarding/': typeof OnboardingIndexRoute
  '/character/$character': typeof AuthenticatedCharacterCharacterRoute
  '/diary/$thoughtId': typeof AuthenticatedDiaryThoughtIdRoute
  '/diary/new': typeof AuthenticatedDiaryNewRoute
  '/feed/new': typeof AuthenticatedFeedNewRoute
  '/friend/$friendId': typeof AuthenticatedFriendFriendIdRouteWithChildren
  '/home/new': typeof AuthenticatedHomeNewRoute
  '/profile/avatar': typeof AuthenticatedProfileAvatarRoute
  '/profile/ei-leaderboard': typeof AuthenticatedProfileEiLeaderboardRoute
  '/profile/ei-result': typeof AuthenticatedProfileEiResultRoute
  '/profile/ei-test': typeof AuthenticatedProfileEiTestRoute
  '/profile/friends-language': typeof AuthenticatedProfileFriendsLanguageRoute
  '/profile/interface-language': typeof AuthenticatedProfileInterfaceLanguageRoute
  '/profile/personality': typeof AuthenticatedProfilePersonalityRoute
  '/profile/personality-share': typeof AuthenticatedProfilePersonalityShareRoute
  '/profile/rank': typeof AuthenticatedProfileRankRoute
  '/profile/rank-points': typeof AuthenticatedProfileRankPointsRoute
  '/social-match/dashboard': typeof AuthenticatedSocialMatchDashboardRoute
  '/social-match/request': typeof AuthenticatedSocialMatchRequestRoute
  '/social-match/submitted': typeof AuthenticatedSocialMatchSubmittedRoute
  '/chat/': typeof AuthenticatedChatIndexRoute
  '/diary/': typeof AuthenticatedDiaryIndexRoute
  '/feed/': typeof AuthenticatedFeedIndexRoute
  '/home/': typeof AuthenticatedHomeIndexRoute
  '/profile/': typeof AuthenticatedProfileIndexRoute
  '/social-match/': typeof AuthenticatedSocialMatchIndexRoute
  '/board/character/$character': typeof AuthenticatedBoardCharacterCharacterRoute
  '/board/friend/$friendId': typeof AuthenticatedBoardFriendFriendIdRoute
  '/friend/$friendId/personality': typeof AuthenticatedFriendFriendIdPersonalityRoute
  '/friend/$friendId/scenario': typeof AuthenticatedFriendFriendIdScenarioRoute
  '/new-contact/preview/$friendId': typeof AuthenticatedNewContactPreviewFriendIdRoute
  '/profile/blacklist/$friendId': typeof AuthenticatedProfileBlacklistFriendIdRoute
  '/profile/email/send': typeof AuthenticatedProfileEmailSendRoute
  '/profile/email/verify': typeof AuthenticatedProfileEmailVerifyRoute
  '/profile/subscription/change': typeof AuthenticatedProfileSubscriptionChangeRoute
  '/friend/$friendId/': typeof AuthenticatedFriendFriendIdIndexRoute
  '/profile/blacklist/': typeof AuthenticatedProfileBlacklistIndexRoute
  '/profile/subscription/': typeof AuthenticatedProfileSubscriptionIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/user-blocked': typeof UserBlockedRoute
  '/verify-age': typeof AuthenticatedVerifyAgeRoute
  '/onboarding/language': typeof OnboardingLanguageRoute
  '/onboarding/name': typeof OnboardingNameRoute
  '/onboarding/signin-email': typeof OnboardingSigninEmailRoute
  '/onboarding/signin-verification': typeof OnboardingSigninVerificationRoute
  '/onboarding/signin-welcome': typeof OnboardingSigninWelcomeRoute
  '/onboarding/signup-age-restricted': typeof OnboardingSignupAgeRestrictedRoute
  '/onboarding/signup-city': typeof OnboardingSignupCityRoute
  '/onboarding/signup-date-of-birth': typeof OnboardingSignupDateOfBirthRoute
  '/onboarding/signup-email': typeof OnboardingSignupEmailRoute
  '/onboarding/signup-email-already-exists': typeof OnboardingSignupEmailAlreadyExistsRoute
  '/onboarding/signup-email-change': typeof OnboardingSignupEmailChangeRoute
  '/onboarding/signup-email-verification': typeof OnboardingSignupEmailVerificationRoute
  '/onboarding/signup-gender': typeof OnboardingSignupGenderRoute
  '/onboarding/signup-heard-about': typeof OnboardingSignupHeardAboutRoute
  '/onboarding/signup-instagram': typeof OnboardingSignupInstagramRoute
  '/onboarding/signup-intention': typeof OnboardingSignupIntentionRoute
  '/onboarding/signup-welcome': typeof OnboardingSignupWelcomeRoute
  '/onboarding': typeof OnboardingIndexRoute
  '/character/$character': typeof AuthenticatedCharacterCharacterRoute
  '/diary/$thoughtId': typeof AuthenticatedDiaryThoughtIdRoute
  '/diary/new': typeof AuthenticatedDiaryNewRoute
  '/feed/new': typeof AuthenticatedFeedNewRoute
  '/home/new': typeof AuthenticatedHomeNewRoute
  '/profile/avatar': typeof AuthenticatedProfileAvatarRoute
  '/profile/ei-leaderboard': typeof AuthenticatedProfileEiLeaderboardRoute
  '/profile/ei-result': typeof AuthenticatedProfileEiResultRoute
  '/profile/ei-test': typeof AuthenticatedProfileEiTestRoute
  '/profile/friends-language': typeof AuthenticatedProfileFriendsLanguageRoute
  '/profile/interface-language': typeof AuthenticatedProfileInterfaceLanguageRoute
  '/profile/personality': typeof AuthenticatedProfilePersonalityRoute
  '/profile/personality-share': typeof AuthenticatedProfilePersonalityShareRoute
  '/profile/rank': typeof AuthenticatedProfileRankRoute
  '/profile/rank-points': typeof AuthenticatedProfileRankPointsRoute
  '/social-match/dashboard': typeof AuthenticatedSocialMatchDashboardRoute
  '/social-match/request': typeof AuthenticatedSocialMatchRequestRoute
  '/social-match/submitted': typeof AuthenticatedSocialMatchSubmittedRoute
  '/chat': typeof AuthenticatedChatIndexRoute
  '/diary': typeof AuthenticatedDiaryIndexRoute
  '/feed': typeof AuthenticatedFeedIndexRoute
  '/home': typeof AuthenticatedHomeIndexRoute
  '/profile': typeof AuthenticatedProfileIndexRoute
  '/social-match': typeof AuthenticatedSocialMatchIndexRoute
  '/board/character/$character': typeof AuthenticatedBoardCharacterCharacterRoute
  '/board/friend/$friendId': typeof AuthenticatedBoardFriendFriendIdRoute
  '/friend/$friendId/personality': typeof AuthenticatedFriendFriendIdPersonalityRoute
  '/friend/$friendId/scenario': typeof AuthenticatedFriendFriendIdScenarioRoute
  '/new-contact/preview/$friendId': typeof AuthenticatedNewContactPreviewFriendIdRoute
  '/profile/blacklist/$friendId': typeof AuthenticatedProfileBlacklistFriendIdRoute
  '/profile/email/send': typeof AuthenticatedProfileEmailSendRoute
  '/profile/email/verify': typeof AuthenticatedProfileEmailVerifyRoute
  '/profile/subscription/change': typeof AuthenticatedProfileSubscriptionChangeRoute
  '/friend/$friendId': typeof AuthenticatedFriendFriendIdIndexRoute
  '/profile/blacklist': typeof AuthenticatedProfileBlacklistIndexRoute
  '/profile/subscription': typeof AuthenticatedProfileSubscriptionIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/_authenticated': typeof AuthenticatedRouteWithChildren
  '/onboarding': typeof OnboardingRouteWithChildren
  '/user-blocked': typeof UserBlockedRoute
  '/_authenticated/diary': typeof AuthenticatedDiaryRouteRouteWithChildren
  '/_authenticated/social-match': typeof AuthenticatedSocialMatchRouteRouteWithChildren
  '/_authenticated/verify-age': typeof AuthenticatedVerifyAgeRoute
  '/onboarding/language': typeof OnboardingLanguageRoute
  '/onboarding/name': typeof OnboardingNameRoute
  '/onboarding/signin-email': typeof OnboardingSigninEmailRoute
  '/onboarding/signin-verification': typeof OnboardingSigninVerificationRoute
  '/onboarding/signin-welcome': typeof OnboardingSigninWelcomeRoute
  '/onboarding/signup-age-restricted': typeof OnboardingSignupAgeRestrictedRoute
  '/onboarding/signup-city': typeof OnboardingSignupCityRoute
  '/onboarding/signup-date-of-birth': typeof OnboardingSignupDateOfBirthRoute
  '/onboarding/signup-email': typeof OnboardingSignupEmailRoute
  '/onboarding/signup-email-already-exists': typeof OnboardingSignupEmailAlreadyExistsRoute
  '/onboarding/signup-email-change': typeof OnboardingSignupEmailChangeRoute
  '/onboarding/signup-email-verification': typeof OnboardingSignupEmailVerificationRoute
  '/onboarding/signup-gender': typeof OnboardingSignupGenderRoute
  '/onboarding/signup-heard-about': typeof OnboardingSignupHeardAboutRoute
  '/onboarding/signup-instagram': typeof OnboardingSignupInstagramRoute
  '/onboarding/signup-intention': typeof OnboardingSignupIntentionRoute
  '/onboarding/signup-welcome': typeof OnboardingSignupWelcomeRoute
  '/onboarding/': typeof OnboardingIndexRoute
  '/_authenticated/character/$character': typeof AuthenticatedCharacterCharacterRoute
  '/_authenticated/diary/$thoughtId': typeof AuthenticatedDiaryThoughtIdRoute
  '/_authenticated/diary/new': typeof AuthenticatedDiaryNewRoute
  '/_authenticated/feed/new': typeof AuthenticatedFeedNewRoute
  '/_authenticated/friend/$friendId': typeof AuthenticatedFriendFriendIdRouteWithChildren
  '/_authenticated/home/new': typeof AuthenticatedHomeNewRoute
  '/_authenticated/profile/avatar': typeof AuthenticatedProfileAvatarRoute
  '/_authenticated/profile/ei-leaderboard': typeof AuthenticatedProfileEiLeaderboardRoute
  '/_authenticated/profile/ei-result': typeof AuthenticatedProfileEiResultRoute
  '/_authenticated/profile/ei-test': typeof AuthenticatedProfileEiTestRoute
  '/_authenticated/profile/friends-language': typeof AuthenticatedProfileFriendsLanguageRoute
  '/_authenticated/profile/interface-language': typeof AuthenticatedProfileInterfaceLanguageRoute
  '/_authenticated/profile/personality': typeof AuthenticatedProfilePersonalityRoute
  '/_authenticated/profile/personality-share': typeof AuthenticatedProfilePersonalityShareRoute
  '/_authenticated/profile/rank': typeof AuthenticatedProfileRankRoute
  '/_authenticated/profile/rank-points': typeof AuthenticatedProfileRankPointsRoute
  '/_authenticated/social-match/dashboard': typeof AuthenticatedSocialMatchDashboardRoute
  '/_authenticated/social-match/request': typeof AuthenticatedSocialMatchRequestRoute
  '/_authenticated/social-match/submitted': typeof AuthenticatedSocialMatchSubmittedRoute
  '/_authenticated/chat/': typeof AuthenticatedChatIndexRoute
  '/_authenticated/diary/': typeof AuthenticatedDiaryIndexRoute
  '/_authenticated/feed/': typeof AuthenticatedFeedIndexRoute
  '/_authenticated/home/': typeof AuthenticatedHomeIndexRoute
  '/_authenticated/profile/': typeof AuthenticatedProfileIndexRoute
  '/_authenticated/social-match/': typeof AuthenticatedSocialMatchIndexRoute
  '/_authenticated/board/character/$character': typeof AuthenticatedBoardCharacterCharacterRoute
  '/_authenticated/board/friend/$friendId': typeof AuthenticatedBoardFriendFriendIdRoute
  '/_authenticated/friend/$friendId/personality': typeof AuthenticatedFriendFriendIdPersonalityRoute
  '/_authenticated/friend/$friendId/scenario': typeof AuthenticatedFriendFriendIdScenarioRoute
  '/_authenticated/new-contact/preview/$friendId': typeof AuthenticatedNewContactPreviewFriendIdRoute
  '/_authenticated/profile/blacklist/$friendId': typeof AuthenticatedProfileBlacklistFriendIdRoute
  '/_authenticated/profile/email/send': typeof AuthenticatedProfileEmailSendRoute
  '/_authenticated/profile/email/verify': typeof AuthenticatedProfileEmailVerifyRoute
  '/_authenticated/profile/subscription/change': typeof AuthenticatedProfileSubscriptionChangeRoute
  '/_authenticated/friend/$friendId/': typeof AuthenticatedFriendFriendIdIndexRoute
  '/_authenticated/profile/blacklist/': typeof AuthenticatedProfileBlacklistIndexRoute
  '/_authenticated/profile/subscription/': typeof AuthenticatedProfileSubscriptionIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/onboarding'
    | '/user-blocked'
    | '/diary'
    | '/social-match'
    | '/verify-age'
    | '/onboarding/language'
    | '/onboarding/name'
    | '/onboarding/signin-email'
    | '/onboarding/signin-verification'
    | '/onboarding/signin-welcome'
    | '/onboarding/signup-age-restricted'
    | '/onboarding/signup-city'
    | '/onboarding/signup-date-of-birth'
    | '/onboarding/signup-email'
    | '/onboarding/signup-email-already-exists'
    | '/onboarding/signup-email-change'
    | '/onboarding/signup-email-verification'
    | '/onboarding/signup-gender'
    | '/onboarding/signup-heard-about'
    | '/onboarding/signup-instagram'
    | '/onboarding/signup-intention'
    | '/onboarding/signup-welcome'
    | '/onboarding/'
    | '/character/$character'
    | '/diary/$thoughtId'
    | '/diary/new'
    | '/feed/new'
    | '/friend/$friendId'
    | '/home/new'
    | '/profile/avatar'
    | '/profile/ei-leaderboard'
    | '/profile/ei-result'
    | '/profile/ei-test'
    | '/profile/friends-language'
    | '/profile/interface-language'
    | '/profile/personality'
    | '/profile/personality-share'
    | '/profile/rank'
    | '/profile/rank-points'
    | '/social-match/dashboard'
    | '/social-match/request'
    | '/social-match/submitted'
    | '/chat/'
    | '/diary/'
    | '/feed/'
    | '/home/'
    | '/profile/'
    | '/social-match/'
    | '/board/character/$character'
    | '/board/friend/$friendId'
    | '/friend/$friendId/personality'
    | '/friend/$friendId/scenario'
    | '/new-contact/preview/$friendId'
    | '/profile/blacklist/$friendId'
    | '/profile/email/send'
    | '/profile/email/verify'
    | '/profile/subscription/change'
    | '/friend/$friendId/'
    | '/profile/blacklist/'
    | '/profile/subscription/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/user-blocked'
    | '/verify-age'
    | '/onboarding/language'
    | '/onboarding/name'
    | '/onboarding/signin-email'
    | '/onboarding/signin-verification'
    | '/onboarding/signin-welcome'
    | '/onboarding/signup-age-restricted'
    | '/onboarding/signup-city'
    | '/onboarding/signup-date-of-birth'
    | '/onboarding/signup-email'
    | '/onboarding/signup-email-already-exists'
    | '/onboarding/signup-email-change'
    | '/onboarding/signup-email-verification'
    | '/onboarding/signup-gender'
    | '/onboarding/signup-heard-about'
    | '/onboarding/signup-instagram'
    | '/onboarding/signup-intention'
    | '/onboarding/signup-welcome'
    | '/onboarding'
    | '/character/$character'
    | '/diary/$thoughtId'
    | '/diary/new'
    | '/feed/new'
    | '/home/new'
    | '/profile/avatar'
    | '/profile/ei-leaderboard'
    | '/profile/ei-result'
    | '/profile/ei-test'
    | '/profile/friends-language'
    | '/profile/interface-language'
    | '/profile/personality'
    | '/profile/personality-share'
    | '/profile/rank'
    | '/profile/rank-points'
    | '/social-match/dashboard'
    | '/social-match/request'
    | '/social-match/submitted'
    | '/chat'
    | '/diary'
    | '/feed'
    | '/home'
    | '/profile'
    | '/social-match'
    | '/board/character/$character'
    | '/board/friend/$friendId'
    | '/friend/$friendId/personality'
    | '/friend/$friendId/scenario'
    | '/new-contact/preview/$friendId'
    | '/profile/blacklist/$friendId'
    | '/profile/email/send'
    | '/profile/email/verify'
    | '/profile/subscription/change'
    | '/friend/$friendId'
    | '/profile/blacklist'
    | '/profile/subscription'
  id:
    | '__root__'
    | '/'
    | '/_authenticated'
    | '/onboarding'
    | '/user-blocked'
    | '/_authenticated/diary'
    | '/_authenticated/social-match'
    | '/_authenticated/verify-age'
    | '/onboarding/language'
    | '/onboarding/name'
    | '/onboarding/signin-email'
    | '/onboarding/signin-verification'
    | '/onboarding/signin-welcome'
    | '/onboarding/signup-age-restricted'
    | '/onboarding/signup-city'
    | '/onboarding/signup-date-of-birth'
    | '/onboarding/signup-email'
    | '/onboarding/signup-email-already-exists'
    | '/onboarding/signup-email-change'
    | '/onboarding/signup-email-verification'
    | '/onboarding/signup-gender'
    | '/onboarding/signup-heard-about'
    | '/onboarding/signup-instagram'
    | '/onboarding/signup-intention'
    | '/onboarding/signup-welcome'
    | '/onboarding/'
    | '/_authenticated/character/$character'
    | '/_authenticated/diary/$thoughtId'
    | '/_authenticated/diary/new'
    | '/_authenticated/feed/new'
    | '/_authenticated/friend/$friendId'
    | '/_authenticated/home/new'
    | '/_authenticated/profile/avatar'
    | '/_authenticated/profile/ei-leaderboard'
    | '/_authenticated/profile/ei-result'
    | '/_authenticated/profile/ei-test'
    | '/_authenticated/profile/friends-language'
    | '/_authenticated/profile/interface-language'
    | '/_authenticated/profile/personality'
    | '/_authenticated/profile/personality-share'
    | '/_authenticated/profile/rank'
    | '/_authenticated/profile/rank-points'
    | '/_authenticated/social-match/dashboard'
    | '/_authenticated/social-match/request'
    | '/_authenticated/social-match/submitted'
    | '/_authenticated/chat/'
    | '/_authenticated/diary/'
    | '/_authenticated/feed/'
    | '/_authenticated/home/'
    | '/_authenticated/profile/'
    | '/_authenticated/social-match/'
    | '/_authenticated/board/character/$character'
    | '/_authenticated/board/friend/$friendId'
    | '/_authenticated/friend/$friendId/personality'
    | '/_authenticated/friend/$friendId/scenario'
    | '/_authenticated/new-contact/preview/$friendId'
    | '/_authenticated/profile/blacklist/$friendId'
    | '/_authenticated/profile/email/send'
    | '/_authenticated/profile/email/verify'
    | '/_authenticated/profile/subscription/change'
    | '/_authenticated/friend/$friendId/'
    | '/_authenticated/profile/blacklist/'
    | '/_authenticated/profile/subscription/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AuthenticatedRoute: typeof AuthenticatedRouteWithChildren
  OnboardingRoute: typeof OnboardingRouteWithChildren
  UserBlockedRoute: typeof UserBlockedRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authenticated': {
      id: '/_authenticated'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AuthenticatedRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/onboarding': {
      id: '/onboarding'
      path: '/onboarding'
      fullPath: '/onboarding'
      preLoaderRoute: typeof OnboardingRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/user-blocked': {
      id: '/user-blocked'
      path: '/user-blocked'
      fullPath: '/user-blocked'
      preLoaderRoute: typeof UserBlockedRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authenticated/diary': {
      id: '/_authenticated/diary'
      path: '/diary'
      fullPath: '/diary'
      preLoaderRoute: typeof AuthenticatedDiaryRouteRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/social-match': {
      id: '/_authenticated/social-match'
      path: '/social-match'
      fullPath: '/social-match'
      preLoaderRoute: typeof AuthenticatedSocialMatchRouteRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/verify-age': {
      id: '/_authenticated/verify-age'
      path: '/verify-age'
      fullPath: '/verify-age'
      preLoaderRoute: typeof AuthenticatedVerifyAgeRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/onboarding/': {
      id: '/onboarding/'
      path: '/'
      fullPath: '/onboarding/'
      preLoaderRoute: typeof OnboardingIndexRouteImport
      parentRoute: typeof OnboardingRoute
    }
    '/onboarding/language': {
      id: '/onboarding/language'
      path: '/language'
      fullPath: '/onboarding/language'
      preLoaderRoute: typeof OnboardingLanguageRouteImport
      parentRoute: typeof OnboardingRoute
    }
    '/onboarding/name': {
      id: '/onboarding/name'
      path: '/name'
      fullPath: '/onboarding/name'
      preLoaderRoute: typeof OnboardingNameRouteImport
      parentRoute: typeof OnboardingRoute
    }
    '/onboarding/signin-email': {
      id: '/onboarding/signin-email'
      path: '/signin-email'
      fullPath: '/onboarding/signin-email'
      preLoaderRoute: typeof OnboardingSigninEmailRouteImport
      parentRoute: typeof OnboardingRoute
    }
    '/onboarding/signin-verification': {
      id: '/onboarding/signin-verification'
      path: '/signin-verification'
      fullPath: '/onboarding/signin-verification'
      preLoaderRoute: typeof OnboardingSigninVerificationRouteImport
      parentRoute: typeof OnboardingRoute
    }
    '/onboarding/signin-welcome': {
      id: '/onboarding/signin-welcome'
      path: '/signin-welcome'
      fullPath: '/onboarding/signin-welcome'
      preLoaderRoute: typeof OnboardingSigninWelcomeRouteImport
      parentRoute: typeof OnboardingRoute
    }
    '/onboarding/signup-age-restricted': {
      id: '/onboarding/signup-age-restricted'
      path: '/signup-age-restricted'
      fullPath: '/onboarding/signup-age-restricted'
      preLoaderRoute: typeof OnboardingSignupAgeRestrictedRouteImport
      parentRoute: typeof OnboardingRoute
    }
    '/onboarding/signup-city': {
      id: '/onboarding/signup-city'
      path: '/signup-city'
      fullPath: '/onboarding/signup-city'
      preLoaderRoute: typeof OnboardingSignupCityRouteImport
      parentRoute: typeof OnboardingRoute
    }
    '/onboarding/signup-date-of-birth': {
      id: '/onboarding/signup-date-of-birth'
      path: '/signup-date-of-birth'
      fullPath: '/onboarding/signup-date-of-birth'
      preLoaderRoute: typeof OnboardingSignupDateOfBirthRouteImport
      parentRoute: typeof OnboardingRoute
    }
    '/onboarding/signup-email': {
      id: '/onboarding/signup-email'
      path: '/signup-email'
      fullPath: '/onboarding/signup-email'
      preLoaderRoute: typeof OnboardingSignupEmailRouteImport
      parentRoute: typeof OnboardingRoute
    }
    '/onboarding/signup-email-already-exists': {
      id: '/onboarding/signup-email-already-exists'
      path: '/signup-email-already-exists'
      fullPath: '/onboarding/signup-email-already-exists'
      preLoaderRoute: typeof OnboardingSignupEmailAlreadyExistsRouteImport
      parentRoute: typeof OnboardingRoute
    }
    '/onboarding/signup-email-change': {
      id: '/onboarding/signup-email-change'
      path: '/signup-email-change'
      fullPath: '/onboarding/signup-email-change'
      preLoaderRoute: typeof OnboardingSignupEmailChangeRouteImport
      parentRoute: typeof OnboardingRoute
    }
    '/onboarding/signup-email-verification': {
      id: '/onboarding/signup-email-verification'
      path: '/signup-email-verification'
      fullPath: '/onboarding/signup-email-verification'
      preLoaderRoute: typeof OnboardingSignupEmailVerificationRouteImport
      parentRoute: typeof OnboardingRoute
    }
    '/onboarding/signup-gender': {
      id: '/onboarding/signup-gender'
      path: '/signup-gender'
      fullPath: '/onboarding/signup-gender'
      preLoaderRoute: typeof OnboardingSignupGenderRouteImport
      parentRoute: typeof OnboardingRoute
    }
    '/onboarding/signup-heard-about': {
      id: '/onboarding/signup-heard-about'
      path: '/signup-heard-about'
      fullPath: '/onboarding/signup-heard-about'
      preLoaderRoute: typeof OnboardingSignupHeardAboutRouteImport
      parentRoute: typeof OnboardingRoute
    }
    '/onboarding/signup-instagram': {
      id: '/onboarding/signup-instagram'
      path: '/signup-instagram'
      fullPath: '/onboarding/signup-instagram'
      preLoaderRoute: typeof OnboardingSignupInstagramRouteImport
      parentRoute: typeof OnboardingRoute
    }
    '/onboarding/signup-intention': {
      id: '/onboarding/signup-intention'
      path: '/signup-intention'
      fullPath: '/onboarding/signup-intention'
      preLoaderRoute: typeof OnboardingSignupIntentionRouteImport
      parentRoute: typeof OnboardingRoute
    }
    '/onboarding/signup-welcome': {
      id: '/onboarding/signup-welcome'
      path: '/signup-welcome'
      fullPath: '/onboarding/signup-welcome'
      preLoaderRoute: typeof OnboardingSignupWelcomeRouteImport
      parentRoute: typeof OnboardingRoute
    }
    '/_authenticated/character/$character': {
      id: '/_authenticated/character/$character'
      path: '/character/$character'
      fullPath: '/character/$character'
      preLoaderRoute: typeof AuthenticatedCharacterCharacterRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/chat/': {
      id: '/_authenticated/chat/'
      path: '/chat'
      fullPath: '/chat/'
      preLoaderRoute: typeof AuthenticatedChatIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/diary/': {
      id: '/_authenticated/diary/'
      path: '/'
      fullPath: '/diary/'
      preLoaderRoute: typeof AuthenticatedDiaryIndexRouteImport
      parentRoute: typeof AuthenticatedDiaryRouteRoute
    }
    '/_authenticated/diary/$thoughtId': {
      id: '/_authenticated/diary/$thoughtId'
      path: '/$thoughtId'
      fullPath: '/diary/$thoughtId'
      preLoaderRoute: typeof AuthenticatedDiaryThoughtIdRouteImport
      parentRoute: typeof AuthenticatedDiaryRouteRoute
    }
    '/_authenticated/diary/new': {
      id: '/_authenticated/diary/new'
      path: '/new'
      fullPath: '/diary/new'
      preLoaderRoute: typeof AuthenticatedDiaryNewRouteImport
      parentRoute: typeof AuthenticatedDiaryRouteRoute
    }
    '/_authenticated/feed/': {
      id: '/_authenticated/feed/'
      path: '/feed'
      fullPath: '/feed/'
      preLoaderRoute: typeof AuthenticatedFeedIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/feed/new': {
      id: '/_authenticated/feed/new'
      path: '/feed/new'
      fullPath: '/feed/new'
      preLoaderRoute: typeof AuthenticatedFeedNewRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/friend/$friendId': {
      id: '/_authenticated/friend/$friendId'
      path: '/friend/$friendId'
      fullPath: '/friend/$friendId'
      preLoaderRoute: typeof AuthenticatedFriendFriendIdRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/home/': {
      id: '/_authenticated/home/'
      path: '/home'
      fullPath: '/home/'
      preLoaderRoute: typeof AuthenticatedHomeIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/home/new': {
      id: '/_authenticated/home/new'
      path: '/home/new'
      fullPath: '/home/new'
      preLoaderRoute: typeof AuthenticatedHomeNewRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/profile/': {
      id: '/_authenticated/profile/'
      path: '/profile'
      fullPath: '/profile/'
      preLoaderRoute: typeof AuthenticatedProfileIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/profile/avatar': {
      id: '/_authenticated/profile/avatar'
      path: '/profile/avatar'
      fullPath: '/profile/avatar'
      preLoaderRoute: typeof AuthenticatedProfileAvatarRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/profile/ei-leaderboard': {
      id: '/_authenticated/profile/ei-leaderboard'
      path: '/profile/ei-leaderboard'
      fullPath: '/profile/ei-leaderboard'
      preLoaderRoute: typeof AuthenticatedProfileEiLeaderboardRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/profile/ei-result': {
      id: '/_authenticated/profile/ei-result'
      path: '/profile/ei-result'
      fullPath: '/profile/ei-result'
      preLoaderRoute: typeof AuthenticatedProfileEiResultRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/profile/ei-test': {
      id: '/_authenticated/profile/ei-test'
      path: '/profile/ei-test'
      fullPath: '/profile/ei-test'
      preLoaderRoute: typeof AuthenticatedProfileEiTestRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/profile/friends-language': {
      id: '/_authenticated/profile/friends-language'
      path: '/profile/friends-language'
      fullPath: '/profile/friends-language'
      preLoaderRoute: typeof AuthenticatedProfileFriendsLanguageRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/profile/interface-language': {
      id: '/_authenticated/profile/interface-language'
      path: '/profile/interface-language'
      fullPath: '/profile/interface-language'
      preLoaderRoute: typeof AuthenticatedProfileInterfaceLanguageRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/profile/personality': {
      id: '/_authenticated/profile/personality'
      path: '/profile/personality'
      fullPath: '/profile/personality'
      preLoaderRoute: typeof AuthenticatedProfilePersonalityRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/profile/personality-share': {
      id: '/_authenticated/profile/personality-share'
      path: '/profile/personality-share'
      fullPath: '/profile/personality-share'
      preLoaderRoute: typeof AuthenticatedProfilePersonalityShareRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/profile/rank': {
      id: '/_authenticated/profile/rank'
      path: '/profile/rank'
      fullPath: '/profile/rank'
      preLoaderRoute: typeof AuthenticatedProfileRankRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/profile/rank-points': {
      id: '/_authenticated/profile/rank-points'
      path: '/profile/rank-points'
      fullPath: '/profile/rank-points'
      preLoaderRoute: typeof AuthenticatedProfileRankPointsRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/social-match/': {
      id: '/_authenticated/social-match/'
      path: '/'
      fullPath: '/social-match/'
      preLoaderRoute: typeof AuthenticatedSocialMatchIndexRouteImport
      parentRoute: typeof AuthenticatedSocialMatchRouteRoute
    }
    '/_authenticated/social-match/dashboard': {
      id: '/_authenticated/social-match/dashboard'
      path: '/dashboard'
      fullPath: '/social-match/dashboard'
      preLoaderRoute: typeof AuthenticatedSocialMatchDashboardRouteImport
      parentRoute: typeof AuthenticatedSocialMatchRouteRoute
    }
    '/_authenticated/social-match/request': {
      id: '/_authenticated/social-match/request'
      path: '/request'
      fullPath: '/social-match/request'
      preLoaderRoute: typeof AuthenticatedSocialMatchRequestRouteImport
      parentRoute: typeof AuthenticatedSocialMatchRouteRoute
    }
    '/_authenticated/social-match/submitted': {
      id: '/_authenticated/social-match/submitted'
      path: '/submitted'
      fullPath: '/social-match/submitted'
      preLoaderRoute: typeof AuthenticatedSocialMatchSubmittedRouteImport
      parentRoute: typeof AuthenticatedSocialMatchRouteRoute
    }
    '/_authenticated/board/character/$character': {
      id: '/_authenticated/board/character/$character'
      path: '/board/character/$character'
      fullPath: '/board/character/$character'
      preLoaderRoute: typeof AuthenticatedBoardCharacterCharacterRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/board/friend/$friendId': {
      id: '/_authenticated/board/friend/$friendId'
      path: '/board/friend/$friendId'
      fullPath: '/board/friend/$friendId'
      preLoaderRoute: typeof AuthenticatedBoardFriendFriendIdRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/friend/$friendId/': {
      id: '/_authenticated/friend/$friendId/'
      path: '/'
      fullPath: '/friend/$friendId/'
      preLoaderRoute: typeof AuthenticatedFriendFriendIdIndexRouteImport
      parentRoute: typeof AuthenticatedFriendFriendIdRoute
    }
    '/_authenticated/friend/$friendId/personality': {
      id: '/_authenticated/friend/$friendId/personality'
      path: '/personality'
      fullPath: '/friend/$friendId/personality'
      preLoaderRoute: typeof AuthenticatedFriendFriendIdPersonalityRouteImport
      parentRoute: typeof AuthenticatedFriendFriendIdRoute
    }
    '/_authenticated/friend/$friendId/scenario': {
      id: '/_authenticated/friend/$friendId/scenario'
      path: '/scenario'
      fullPath: '/friend/$friendId/scenario'
      preLoaderRoute: typeof AuthenticatedFriendFriendIdScenarioRouteImport
      parentRoute: typeof AuthenticatedFriendFriendIdRoute
    }
    '/_authenticated/new-contact/preview/$friendId': {
      id: '/_authenticated/new-contact/preview/$friendId'
      path: '/new-contact/preview/$friendId'
      fullPath: '/new-contact/preview/$friendId'
      preLoaderRoute: typeof AuthenticatedNewContactPreviewFriendIdRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/profile/blacklist/': {
      id: '/_authenticated/profile/blacklist/'
      path: '/profile/blacklist'
      fullPath: '/profile/blacklist/'
      preLoaderRoute: typeof AuthenticatedProfileBlacklistIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/profile/blacklist/$friendId': {
      id: '/_authenticated/profile/blacklist/$friendId'
      path: '/profile/blacklist/$friendId'
      fullPath: '/profile/blacklist/$friendId'
      preLoaderRoute: typeof AuthenticatedProfileBlacklistFriendIdRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/profile/email/send': {
      id: '/_authenticated/profile/email/send'
      path: '/profile/email/send'
      fullPath: '/profile/email/send'
      preLoaderRoute: typeof AuthenticatedProfileEmailSendRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/profile/email/verify': {
      id: '/_authenticated/profile/email/verify'
      path: '/profile/email/verify'
      fullPath: '/profile/email/verify'
      preLoaderRoute: typeof AuthenticatedProfileEmailVerifyRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/profile/subscription/': {
      id: '/_authenticated/profile/subscription/'
      path: '/profile/subscription'
      fullPath: '/profile/subscription/'
      preLoaderRoute: typeof AuthenticatedProfileSubscriptionIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/profile/subscription/change': {
      id: '/_authenticated/profile/subscription/change'
      path: '/profile/subscription/change'
      fullPath: '/profile/subscription/change'
      preLoaderRoute: typeof AuthenticatedProfileSubscriptionChangeRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
  }
}

interface AuthenticatedDiaryRouteRouteChildren {
  AuthenticatedDiaryThoughtIdRoute: typeof AuthenticatedDiaryThoughtIdRoute
  AuthenticatedDiaryNewRoute: typeof AuthenticatedDiaryNewRoute
  AuthenticatedDiaryIndexRoute: typeof AuthenticatedDiaryIndexRoute
}

const AuthenticatedDiaryRouteRouteChildren: AuthenticatedDiaryRouteRouteChildren =
  {
    AuthenticatedDiaryThoughtIdRoute: AuthenticatedDiaryThoughtIdRoute,
    AuthenticatedDiaryNewRoute: AuthenticatedDiaryNewRoute,
    AuthenticatedDiaryIndexRoute: AuthenticatedDiaryIndexRoute,
  }

const AuthenticatedDiaryRouteRouteWithChildren =
  AuthenticatedDiaryRouteRoute._addFileChildren(
    AuthenticatedDiaryRouteRouteChildren,
  )

interface AuthenticatedSocialMatchRouteRouteChildren {
  AuthenticatedSocialMatchDashboardRoute: typeof AuthenticatedSocialMatchDashboardRoute
  AuthenticatedSocialMatchRequestRoute: typeof AuthenticatedSocialMatchRequestRoute
  AuthenticatedSocialMatchSubmittedRoute: typeof AuthenticatedSocialMatchSubmittedRoute
  AuthenticatedSocialMatchIndexRoute: typeof AuthenticatedSocialMatchIndexRoute
}

const AuthenticatedSocialMatchRouteRouteChildren: AuthenticatedSocialMatchRouteRouteChildren =
  {
    AuthenticatedSocialMatchDashboardRoute:
      AuthenticatedSocialMatchDashboardRoute,
    AuthenticatedSocialMatchRequestRoute: AuthenticatedSocialMatchRequestRoute,
    AuthenticatedSocialMatchSubmittedRoute:
      AuthenticatedSocialMatchSubmittedRoute,
    AuthenticatedSocialMatchIndexRoute: AuthenticatedSocialMatchIndexRoute,
  }

const AuthenticatedSocialMatchRouteRouteWithChildren =
  AuthenticatedSocialMatchRouteRoute._addFileChildren(
    AuthenticatedSocialMatchRouteRouteChildren,
  )

interface AuthenticatedFriendFriendIdRouteChildren {
  AuthenticatedFriendFriendIdPersonalityRoute: typeof AuthenticatedFriendFriendIdPersonalityRoute
  AuthenticatedFriendFriendIdScenarioRoute: typeof AuthenticatedFriendFriendIdScenarioRoute
  AuthenticatedFriendFriendIdIndexRoute: typeof AuthenticatedFriendFriendIdIndexRoute
}

const AuthenticatedFriendFriendIdRouteChildren: AuthenticatedFriendFriendIdRouteChildren =
  {
    AuthenticatedFriendFriendIdPersonalityRoute:
      AuthenticatedFriendFriendIdPersonalityRoute,
    AuthenticatedFriendFriendIdScenarioRoute:
      AuthenticatedFriendFriendIdScenarioRoute,
    AuthenticatedFriendFriendIdIndexRoute:
      AuthenticatedFriendFriendIdIndexRoute,
  }

const AuthenticatedFriendFriendIdRouteWithChildren =
  AuthenticatedFriendFriendIdRoute._addFileChildren(
    AuthenticatedFriendFriendIdRouteChildren,
  )

interface AuthenticatedRouteChildren {
  AuthenticatedDiaryRouteRoute: typeof AuthenticatedDiaryRouteRouteWithChildren
  AuthenticatedSocialMatchRouteRoute: typeof AuthenticatedSocialMatchRouteRouteWithChildren
  AuthenticatedVerifyAgeRoute: typeof AuthenticatedVerifyAgeRoute
  AuthenticatedCharacterCharacterRoute: typeof AuthenticatedCharacterCharacterRoute
  AuthenticatedFeedNewRoute: typeof AuthenticatedFeedNewRoute
  AuthenticatedFriendFriendIdRoute: typeof AuthenticatedFriendFriendIdRouteWithChildren
  AuthenticatedHomeNewRoute: typeof AuthenticatedHomeNewRoute
  AuthenticatedProfileAvatarRoute: typeof AuthenticatedProfileAvatarRoute
  AuthenticatedProfileEiLeaderboardRoute: typeof AuthenticatedProfileEiLeaderboardRoute
  AuthenticatedProfileEiResultRoute: typeof AuthenticatedProfileEiResultRoute
  AuthenticatedProfileEiTestRoute: typeof AuthenticatedProfileEiTestRoute
  AuthenticatedProfileFriendsLanguageRoute: typeof AuthenticatedProfileFriendsLanguageRoute
  AuthenticatedProfileInterfaceLanguageRoute: typeof AuthenticatedProfileInterfaceLanguageRoute
  AuthenticatedProfilePersonalityRoute: typeof AuthenticatedProfilePersonalityRoute
  AuthenticatedProfilePersonalityShareRoute: typeof AuthenticatedProfilePersonalityShareRoute
  AuthenticatedProfileRankRoute: typeof AuthenticatedProfileRankRoute
  AuthenticatedProfileRankPointsRoute: typeof AuthenticatedProfileRankPointsRoute
  AuthenticatedChatIndexRoute: typeof AuthenticatedChatIndexRoute
  AuthenticatedFeedIndexRoute: typeof AuthenticatedFeedIndexRoute
  AuthenticatedHomeIndexRoute: typeof AuthenticatedHomeIndexRoute
  AuthenticatedProfileIndexRoute: typeof AuthenticatedProfileIndexRoute
  AuthenticatedBoardCharacterCharacterRoute: typeof AuthenticatedBoardCharacterCharacterRoute
  AuthenticatedBoardFriendFriendIdRoute: typeof AuthenticatedBoardFriendFriendIdRoute
  AuthenticatedNewContactPreviewFriendIdRoute: typeof AuthenticatedNewContactPreviewFriendIdRoute
  AuthenticatedProfileBlacklistFriendIdRoute: typeof AuthenticatedProfileBlacklistFriendIdRoute
  AuthenticatedProfileEmailSendRoute: typeof AuthenticatedProfileEmailSendRoute
  AuthenticatedProfileEmailVerifyRoute: typeof AuthenticatedProfileEmailVerifyRoute
  AuthenticatedProfileSubscriptionChangeRoute: typeof AuthenticatedProfileSubscriptionChangeRoute
  AuthenticatedProfileBlacklistIndexRoute: typeof AuthenticatedProfileBlacklistIndexRoute
  AuthenticatedProfileSubscriptionIndexRoute: typeof AuthenticatedProfileSubscriptionIndexRoute
}

const AuthenticatedRouteChildren: AuthenticatedRouteChildren = {
  AuthenticatedDiaryRouteRoute: AuthenticatedDiaryRouteRouteWithChildren,
  AuthenticatedSocialMatchRouteRoute:
    AuthenticatedSocialMatchRouteRouteWithChildren,
  AuthenticatedVerifyAgeRoute: AuthenticatedVerifyAgeRoute,
  AuthenticatedCharacterCharacterRoute: AuthenticatedCharacterCharacterRoute,
  AuthenticatedFeedNewRoute: AuthenticatedFeedNewRoute,
  AuthenticatedFriendFriendIdRoute:
    AuthenticatedFriendFriendIdRouteWithChildren,
  AuthenticatedHomeNewRoute: AuthenticatedHomeNewRoute,
  AuthenticatedProfileAvatarRoute: AuthenticatedProfileAvatarRoute,
  AuthenticatedProfileEiLeaderboardRoute:
    AuthenticatedProfileEiLeaderboardRoute,
  AuthenticatedProfileEiResultRoute: AuthenticatedProfileEiResultRoute,
  AuthenticatedProfileEiTestRoute: AuthenticatedProfileEiTestRoute,
  AuthenticatedProfileFriendsLanguageRoute:
    AuthenticatedProfileFriendsLanguageRoute,
  AuthenticatedProfileInterfaceLanguageRoute:
    AuthenticatedProfileInterfaceLanguageRoute,
  AuthenticatedProfilePersonalityRoute: AuthenticatedProfilePersonalityRoute,
  AuthenticatedProfilePersonalityShareRoute:
    AuthenticatedProfilePersonalityShareRoute,
  AuthenticatedProfileRankRoute: AuthenticatedProfileRankRoute,
  AuthenticatedProfileRankPointsRoute: AuthenticatedProfileRankPointsRoute,
  AuthenticatedChatIndexRoute: AuthenticatedChatIndexRoute,
  AuthenticatedFeedIndexRoute: AuthenticatedFeedIndexRoute,
  AuthenticatedHomeIndexRoute: AuthenticatedHomeIndexRoute,
  AuthenticatedProfileIndexRoute: AuthenticatedProfileIndexRoute,
  AuthenticatedBoardCharacterCharacterRoute:
    AuthenticatedBoardCharacterCharacterRoute,
  AuthenticatedBoardFriendFriendIdRoute: AuthenticatedBoardFriendFriendIdRoute,
  AuthenticatedNewContactPreviewFriendIdRoute:
    AuthenticatedNewContactPreviewFriendIdRoute,
  AuthenticatedProfileBlacklistFriendIdRoute:
    AuthenticatedProfileBlacklistFriendIdRoute,
  AuthenticatedProfileEmailSendRoute: AuthenticatedProfileEmailSendRoute,
  AuthenticatedProfileEmailVerifyRoute: AuthenticatedProfileEmailVerifyRoute,
  AuthenticatedProfileSubscriptionChangeRoute:
    AuthenticatedProfileSubscriptionChangeRoute,
  AuthenticatedProfileBlacklistIndexRoute:
    AuthenticatedProfileBlacklistIndexRoute,
  AuthenticatedProfileSubscriptionIndexRoute:
    AuthenticatedProfileSubscriptionIndexRoute,
}

const AuthenticatedRouteWithChildren = AuthenticatedRoute._addFileChildren(
  AuthenticatedRouteChildren,
)

interface OnboardingRouteChildren {
  OnboardingLanguageRoute: typeof OnboardingLanguageRoute
  OnboardingNameRoute: typeof OnboardingNameRoute
  OnboardingSigninEmailRoute: typeof OnboardingSigninEmailRoute
  OnboardingSigninVerificationRoute: typeof OnboardingSigninVerificationRoute
  OnboardingSigninWelcomeRoute: typeof OnboardingSigninWelcomeRoute
  OnboardingSignupAgeRestrictedRoute: typeof OnboardingSignupAgeRestrictedRoute
  OnboardingSignupCityRoute: typeof OnboardingSignupCityRoute
  OnboardingSignupDateOfBirthRoute: typeof OnboardingSignupDateOfBirthRoute
  OnboardingSignupEmailRoute: typeof OnboardingSignupEmailRoute
  OnboardingSignupEmailAlreadyExistsRoute: typeof OnboardingSignupEmailAlreadyExistsRoute
  OnboardingSignupEmailChangeRoute: typeof OnboardingSignupEmailChangeRoute
  OnboardingSignupEmailVerificationRoute: typeof OnboardingSignupEmailVerificationRoute
  OnboardingSignupGenderRoute: typeof OnboardingSignupGenderRoute
  OnboardingSignupHeardAboutRoute: typeof OnboardingSignupHeardAboutRoute
  OnboardingSignupInstagramRoute: typeof OnboardingSignupInstagramRoute
  OnboardingSignupIntentionRoute: typeof OnboardingSignupIntentionRoute
  OnboardingSignupWelcomeRoute: typeof OnboardingSignupWelcomeRoute
  OnboardingIndexRoute: typeof OnboardingIndexRoute
}

const OnboardingRouteChildren: OnboardingRouteChildren = {
  OnboardingLanguageRoute: OnboardingLanguageRoute,
  OnboardingNameRoute: OnboardingNameRoute,
  OnboardingSigninEmailRoute: OnboardingSigninEmailRoute,
  OnboardingSigninVerificationRoute: OnboardingSigninVerificationRoute,
  OnboardingSigninWelcomeRoute: OnboardingSigninWelcomeRoute,
  OnboardingSignupAgeRestrictedRoute: OnboardingSignupAgeRestrictedRoute,
  OnboardingSignupCityRoute: OnboardingSignupCityRoute,
  OnboardingSignupDateOfBirthRoute: OnboardingSignupDateOfBirthRoute,
  OnboardingSignupEmailRoute: OnboardingSignupEmailRoute,
  OnboardingSignupEmailAlreadyExistsRoute:
    OnboardingSignupEmailAlreadyExistsRoute,
  OnboardingSignupEmailChangeRoute: OnboardingSignupEmailChangeRoute,
  OnboardingSignupEmailVerificationRoute:
    OnboardingSignupEmailVerificationRoute,
  OnboardingSignupGenderRoute: OnboardingSignupGenderRoute,
  OnboardingSignupHeardAboutRoute: OnboardingSignupHeardAboutRoute,
  OnboardingSignupInstagramRoute: OnboardingSignupInstagramRoute,
  OnboardingSignupIntentionRoute: OnboardingSignupIntentionRoute,
  OnboardingSignupWelcomeRoute: OnboardingSignupWelcomeRoute,
  OnboardingIndexRoute: OnboardingIndexRoute,
}

const OnboardingRouteWithChildren = OnboardingRoute._addFileChildren(
  OnboardingRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AuthenticatedRoute: AuthenticatedRouteWithChildren,
  OnboardingRoute: OnboardingRouteWithChildren,
  UserBlockedRoute: UserBlockedRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
